/** Labels for the entity types the Admin API records (AuditEntry type names). */
export const ENTITY_TYPES: Record<string, string> = {
  Approval: 'Approval',
  Brand: 'Brand',
  Category: 'Category',
  Complaint: 'Complaint',
  Country: 'Country',
  CountryAvailability: 'Country availability',
  Currency: 'Currency',
  Denomination: 'Denomination',
  Export: 'Export',
  Order: 'Order',
  PaymentChannel: 'Payment channel',
  PaymentChannelOrder: 'Checkout order',
  PricingParameter: 'Pricing parameter',
  PricingCalculation: 'Pricing calculation',
  PricingParameterSet: 'Pricing version',
  Provider: 'Provider',
  ProviderMapping: 'Provider mapping',
  Refund: 'Refund',
  Region: 'Region',
  StaffUser: 'Staff user',
};

export const entityTypeLabel = (type: string) => ENTITY_TYPES[type] ?? type;

/** "CountriesChanged" → "Countries changed". */
export const actionLabel = (action: string) =>
  action.replace(/([a-z])([A-Z])/g, (_match, a: string, b: string) => `${a} ${b.toLowerCase()}`);
